import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Layers, MessageSquareQuote, Image as ImageIcon, Users2, Settings, LogOut, Mails } from "lucide-react";
import Logo from "@/components/site/Logo";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/quotes", label: "Orçamentos", icon: Mails },
  { to: "/admin/simulators", label: "Simuladores", icon: Layers },
  { to: "/admin/testimonials", label: "Depoimentos", icon: MessageSquareQuote },
  { to: "/admin/gallery", label: "Galeria", icon: ImageIcon },
  { to: "/admin/clients", label: "Clientes", icon: Users2 },
  { to: "/admin/settings", label: "Configurações", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex" data-testid="admin-layout">
      <aside className="w-64 hidden md:flex flex-col border-r border-white/5 bg-[#0a0a0a] sticky top-0 h-screen">
        <Link to="/" className="px-5 py-6 border-b border-white/5 block">
          <Logo size={40} wordmarkClass="text-sm" />
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${
                  isActive
                    ? "bg-[#E31B23]/10 text-[#E31B23] border-l-2 border-[#E31B23]"
                    : "text-neutral-400 hover:text-white hover:bg-white/5"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
            >
              <n.icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5">
          <div className="rounded-lg bg-white/5 px-3 py-2 text-xs text-neutral-400 mb-3">
            <div className="text-white font-semibold">{user?.name || "Admin"}</div>
            <div>{user?.email}</div>
          </div>
          <button onClick={doLogout} className="flex items-center gap-2 text-sm text-neutral-400 hover:text-[#E31B23]" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </aside>

      <main className="flex-1 p-6 md:p-10 max-w-full overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
